import { SliderMark, type SliderMarkProps } from '@chakra-ui/react';

export type UiSliderMarkProps = SliderMarkProps;

export const UiSliderMark = SliderMark;
